import React from 'react';
import classnames from 'classnames';
import Element from '../../element';
import styles from './card.module.scss';

interface IProps {
    className?: string;
    children?: React.ReactNode;
}

export default function CardContent({ className, children, ...props }: IProps) {
    return (
        <Element
            {...props}
            className={classnames(styles['bm-card-content'], className)}
        >
            {children}
        </Element>
    );
}
